import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  computed,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { ChunkLoadErrorHandler, HURO_APP_ID } from '@umss/shared/core';
import {
  API_BASE_URL,
  APP_ENVIRONMENT,
  AppContext,
  SUPPORTED_SCOPES,
  authInterceptor,
  baseUrlInterceptor,
  refreshAccount
} from '@umss/shared/core';
import { facebookSdkInitializer } from '@umss/shared/data-access';
import { provideUmssIcons, UmssSplashScreenService } from '@umss/shared/ui';

import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import {
  FacilityContextService,
  FacilityContractorAvailabilityDataService,
  FacilityTabTitleService
} from '@umss/facility/data-access';
import { CONTRACTOR_AVAILABILITY_DATA_SERVICE } from '@umss/shared/data-access';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    FacilityContextService,
    {
      provide: AppContext,
      useExisting: FacilityContextService
    },
    provideAppInitializer(() => refreshAccount()),
    provideAppInitializer(() => {
      inject(FacilityTabTitleService);
      inject(UmssSplashScreenService);
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([baseUrlInterceptor, authInterceptor])),
    provideUmssIcons(),
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    { provide: APP_ENVIRONMENT, useValue: environment },
    {
      provide: HURO_APP_ID,
      useValue: 'facility'
    },
    {
      provide: SUPPORTED_SCOPES,
      useFactory: () => {
        const ctx = inject(FacilityContextService);
        return computed(() => ctx.facility()?.supportedScopes ?? []);
      }
    },
    {
      provide: CONTRACTOR_AVAILABILITY_DATA_SERVICE,
      useClass: FacilityContractorAvailabilityDataService
    },
    facebookSdkInitializer,
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'MM/dd/yyyy' }
    }
  ]
};
